import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  tabSelected: null,
};

/** https://immerjs.github.io/immer/update-patterns/ */
export const slice = createSlice({
  name: 'additionalVideos',
  initialState,
  reducers: {
    setLoadingStateAction: (state, action) => {
      state.isLoading = action.payload;
    },
    setTabSelectedAction: (state, action) => {
      state.tabSelected = action.payload;
    },
    additionalClearAction: () => initialState,
  },
});

export const { setLoadingStateAction, additionalClearAction, setTabSelectedAction } = slice.actions;
